import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import type { ChatDetail } from 'types/api'

export function useChat(id: string) {
  const queryClient = useQueryClient()

  async function getChat() {
    const res = await apiClient.get<ChatDetail>(`${SNA_PREFIX}chats/${id}`)
    queryClient.invalidateQueries({ queryKey: ['chats'] })
    return res.data
  }

  return useQuery({
    queryFn: getChat,
    enabled: !!id,
    queryKey: ['chat', id],
    refetchInterval: 5000
  })
}
